// Plotline integration script

const initializePlotline = () => {
    if (window['plotline']) return;
    window._plotQueue = window._plotQueue || [];
    window.plotline = function(...args) {
        window._plotQueue?.push(args);
    };
    // disabled for event
    return;
    const a = document.createElement('script');
    a.async = true;
    a.src = 'https://sdk.plotline.so/plotline-engage@latest/sdk.min.js';
    const b = document.getElementsByTagName('script')[0];
    b.parentNode?.insertBefore(a, b);
};

export default initializePlotline;
